import { useState } from 'react';
import { format } from 'date-fns';
import {
  useTheme, 
  useMediaQuery,
  Box, 
  Typography, 
  Stack,
  Card, 
  CardHeader, 
  CardContent,
  Chip, 
  Divider,
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow,
  IconButton,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { OPERATOR_LABELS, NO_VALUE_OPS } from './constants';


const filterLabel = (f) =>
  `${f.field} ${OPERATOR_LABELS[f.operator] ?? f.operator}` +
  (!NO_VALUE_OPS.has(f.operator) ? ` "${f.value}"` : '') +
  (f.operator === 'between' ? ` → "${f.valueTo}"` : '');

const HistoryCard = ({ history }) => {
  const theme    = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [open, setOpen] = useState(true);

  if (!history.length) return null;

  return (
    <Card sx={{ borderRadius: 1, border: '1px solid', borderColor: 'divider', flexShrink: 0 }}>
      <CardHeader
        title={<Typography variant="subtitle2" fontWeight={600}>Purge History</Typography>}
        subheader={<Typography variant="caption" color="text.secondary">Current session only</Typography>}
        action={
          <IconButton size="small" onClick={() => setOpen(o => !o)}>
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
        sx={{
          py: 1.5,
          borderBottom: open ? '1px solid' : 'none',
          borderColor: 'divider',
          cursor: 'pointer',
        }}
        onClick={() => setOpen(o => !o)}
      />

      {open && (
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
          {isMobile ? (
            <Stack divider={<Divider />}>
              {history.map((item, i) => (
                <Box key={i} px={2} py={1.5}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.75}>
                    <Typography variant="caption" color="text.secondary">
                      {format(item.timestamp, 'HH:mm:ss')}
                    </Typography>
                    <Chip
                      label={`${item.deletedCount.toLocaleString()} deleted`}
                      color="error"
                      size="small"
                    />
                  </Box>
                  <Typography variant="body2" fontWeight={500}>{item.collection}</Typography>
                  <Stack spacing={0.25} mt={0.5}>
                    {item.filters.map((f, j) => (
                      <Typography key={j} variant="caption" color="text.secondary">
                        {filterLabel(f)}
                      </Typography>
                    ))}
                  </Stack>
                </Box>
              ))}
            </Stack>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Time</TableCell>
                  <TableCell>Collection</TableCell>
                  <TableCell>Filters</TableCell>
                  <TableCell align="right">Deleted</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history.map((item, i) => (
                  <TableRow key={i} hover>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      <Typography variant="caption">{format(item.timestamp, 'HH:mm:ss')}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight={500}>{item.collection}</Typography>
                    </TableCell>
                    <TableCell>
                      <Stack spacing={0.25}>
                        {item.filters.map((f, j) => (
                          <Typography key={j} variant="caption" color="text.secondary">
                            {filterLabel(f)}
                          </Typography>
                        ))}
                      </Stack>
                    </TableCell>
                    <TableCell align="right">
                      <Chip label={item.deletedCount.toLocaleString()} color="error" size="small" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      )}
    </Card>
  );
};

export default HistoryCard;
